import type { JSX, PropsWithChildren } from 'react'
import { tok } from '@sunwebgroup/ui-components'
import { Tag } from '@sunwebgroup/ui-components/uds'
import { css, RuleSet, styled } from 'styled-components'

export type Collection = 'default'
  | 'boutique'
  | 'cycling'
  | 'excellent'
  | 'famfun'
  | 'primavera'
  | 'secrets'
  | 'selections'
  | 'villages'
  | 'xperience'
  | 'atlantis'
  | 'totally'
  | 'child'
  | 'pearls'
  | 'culinary'
  | 'romantic'
  | 'newest-discoveries'

interface CollectionTagProps extends PropsWithChildren {
  collectionName: Collection
}

const StyledTag = styled(Tag)<{ $collectionName: Collection }>`
  color: ${tok('primitives_color_neutral_0')};
  ${({ $collectionName }) => modCollection($collectionName)};
`

export function CollectionTag({ children, collectionName }: CollectionTagProps): JSX.Element {
  return <StyledTag $collectionName={collectionName}>{children}</StyledTag>
}

function modCollection(collectionName: Collection): RuleSet<object> {
  return ({
    'default': css`
      background-color: ${tok('primitives_color_primary_500')};`,
    'boutique': css`
      background-color: ${tok('primitives_color_collection_primary_boutique')};`,
    'cycling': css`
      background-color: ${tok('primitives_color_collection_primary_cycling')};`,
    'excellent': css`
      background-color: ${tok('primitives_color_collection_primary_excellent')};`,
    'famfun': css`
      background-color: ${tok('primitives_color_collection_primary_famfun')};`,
    'primavera': css`
      background-color: ${tok('primitives_color_collection_primary_primavera')};`,
    'secrets': css`
      background-color: ${tok('primitives_color_collection_primary_secrets')};`,
    'selections': css`
      background-color: ${tok('primitives_color_collection_primary_selections')};`,
    'villages': css`
      background-color: ${tok('primitives_color_collection_primary_villages')};`,
    'xperience': css`
      background-color: ${tok('primitives_color_collection_primary_xperience')};`,
    'atlantis': css`
      background-color: ${tok('primitives_color_collection_primary_atlantis')};`,
    'totally': css`
      background-color: ${tok('primitives_color_collection_primary_totally')};`,
    'child': css`
      background-color: ${tok('primitives_color_collection_primary_child')};`,
    'pearls': css`
      background-color: ${tok('primitives_color_collection_primary_pearls')};`,
    'culinary': css`
      background-color: ${tok('primitives_color_collection_primary_culinary')};`,
    'romantic': css`
      background-color: ${tok('primitives_color_collection_primary_honeymoon')};`,
    'newest-discoveries': css`
      background-color: ${tok('primitives_color_collection_primary_newest_discoveries')};`,
  })[collectionName]
}
